/**
 * @CoreConcept(name="Redux Action", description="This is a good Redux action example.
 */

import action from 'app/lib/action';
import {STORE_VISIT} from '../constants/actionTypes';

export default {
    request : (formData) => action(STORE_VISIT.REQUEST)({formData}),
    success : (visit) => action(STORE_VISIT.SUCCESS)({visit}),
    error   : (error) => action(STORE_VISIT.ERROR)({error})
};